import React, {useState} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SimpleButton from '../SimpleButton';
import CustomTooltip from 'components/common/CustomTooltip';

import styles from './ToggleButton.module.scss';
import classNames from 'classnames';

const ToggleButton = props => {
    const {
        name,
        label,
        toggled,
        onChange,
        onChangeField,
        tooltipText,
        disabled = false,
        className: propClassName,
        highOpacity,
    } = props;
    const handleClick = () => {
        if (disabled) return;
        if (onChangeField) {
            onChangeField({target: {name, value: !toggled}});
        } else {
            onChange(!toggled);
        }
    };

    const [tooltipHovered, setTooltipHovered] = useState(false);
    const className = classnames(styles.toggleButton, propClassName, {
        [styles.toggled]: toggled,
        [styles.disabled]: disabled,
        [styles.light]: highOpacity,
    });

    const labelWrapper = classnames(styles.label, {[styles.disabled]: disabled});

    return (
        <SimpleButton className={className} onClick={handleClick}>
            <span
                className={classNames(styles.toggler)}
                onMouseEnter={() => setTooltipHovered(true)}
                onMouseLeave={() => setTooltipHovered(false)}
            >
                <span className={styles.dot} />
            </span>

            <span className={labelWrapper}>{label}</span>
            {tooltipText && (
                <div className={styles.customTooltipContainer}>
                    <CustomTooltip text={tooltipText} displayed={tooltipHovered} className={styles.customTooltip} />
                </div>
            )}
        </SimpleButton>
    );
};

ToggleButton.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    toggled: PropTypes.bool,
    onChange: PropTypes.func,
    onChangeField: PropTypes.func,
};

ToggleButton.defaultProps = {
    name: null,
    label: null,
    toggled: false,
    onChange: null,
    onChangeField: null,
};

export default React.memo(ToggleButton);
